// Singleton trigger for the AuthWizard modal.
//
// Any component (Header "Login" button, PrivateRoute fallback,
// GuestOrSignInModal "Sign in" path, /signup or /signin route redirect)
// calls openAuthWizard() and the <AuthWizardHost> mounted near the App
// root pops the modal. No Redux, no context — a tiny module-level event
// emitter, same pattern as videoCoordinator.
//
// Buffers a single pending open across host-mount races: if the deep-link
// route fires openAuthWizard() in the same render pass that mounts
// AuthWizardHost, sibling useEffect order is undefined and the listener
// can still be null. Hold the opts and replay on register.

let listener = null;
let pending = null;

export function openAuthWizard(opts = {}) {
  if (listener) {
    listener(opts);
  } else {
    pending = opts;
  }
}

// Called by <AuthWizardHost> at mount; returns an unsubscribe.
export function _registerHost(cb) {
  listener = cb;
  if (pending) {
    const opts = pending;
    pending = null;
    cb(opts);
  }
  return () => {
    if (listener === cb) listener = null;
  };
}
